import classnames from "classnames";
import React, { useState } from "react";

import { HitsPerPageConfig } from "@components/Search/SearchResults/StateComponents/HitsPerPage/hitsPerPage.container";

import "./hitsPerPage.scss";

type HitsPerPageComponentProps = {
    items: Array<HitsPerPageConfig>;
    refinedItem?: HitsPerPageConfig;
    refine: (value: number) => void;
    className?: string;
};

const HitsPerPageComponent = ({
    items,
    refine,
    refinedItem,
    className,
}: HitsPerPageComponentProps) => {
    const [optimisticValue, setOptimisticValue] = useState<
        HitsPerPageConfig | undefined
    >(refinedItem);

    const handleOnClickHitsPerPageItem = (item: HitsPerPageConfig) => () => {
        setOptimisticValue(item);
        refine(item.value);
    };

    return (
        <ul className={classnames("hitsPerPage list-unstyled", className)}>
            {items.map(item => (
                <li key={`hitsPerPage-item-${item.value}`}>
                    <button
                        className={classnames(
                            "hitsPerPage__item",
                            item.value === optimisticValue?.value &&
                                "hitsPerPage__item--refined",
                        )}
                        onClick={handleOnClickHitsPerPageItem(item)}
                    >
                        {item.label}
                    </button>
                </li>
            ))}
        </ul>
    );
};

export { HitsPerPageComponent };
